import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { apiPost } from "@/config";

const SubscribeForm = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(null); // "success" | "error" | "already"
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setIsLoading(true);
    setStatus(null);
    try {
      const { data } = await apiPost("/subscribe", { email: email.trim() });
      setStatus(data.message.includes("already") ? "already" : "success");
      setMessage(data.message);
      if (!data.message.includes("already")) setEmail("");
    } catch (err) {
      setStatus("error");
      setMessage(err.response?.data?.detail || "Something went wrong");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div data-testid="subscribe-section" className="mt-8">
      <p className="text-slate-400 text-sm mb-3">Get notified when new articles are published</p>
      <form onSubmit={handleSubmit} className="flex gap-2 max-w-md mx-auto">
        <Input
          data-testid="subscribe-email-input"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="your@email.com"
          className="bg-slate-800 border-slate-600 text-white placeholder:text-slate-500 flex-1"
          required
        />
        <Button
          data-testid="subscribe-submit-button"
          type="submit"
          disabled={isLoading}
          className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-6 shrink-0"
        >
          {isLoading ? "..." : "Subscribe"}
        </Button>
      </form>
      {status && (
        <p data-testid="subscribe-status" className={`text-sm mt-2 ${status === "error" ? "text-red-400" : "text-green-400"}`}>
          {message}
        </p>
      )}
    </div>
  );
};

export default SubscribeForm;
